class BESSAppProjectEditor extends BESSAppBase {

    constructor(container, data, onUpdatedFn) {
        super();
        this.data = data.clone();
        this.container = container;
        this.node = container.find('.app-editor');
        this.viewTotals = container.find('.app-editor-totals');
        this.viewIntro = container.find('.app-editor-intro');
        this.viewToolNotesLink = container.find('.app-editor-tool-notes-link');
        this.userGuideLink = container.find('.app-editor-user-guide-link');
        this.empty = this.node.find('.app-editor-empty');
        this.empty.remove();
        this.viewTotals.hide().removeClass('hidden');
        this.viewIntro.hide().removeClass('hidden');
        this.viewToolNotesLink.hide().removeClass('hidden');
        this.userGuideLink.hide().removeClass('hidden');
        this.syncing = false;
        this.hasChanges = false;
        this.onUpdatedFn = onUpdatedFn;
        this.node.removeClass('app-editor-compact');
        this.multiSelectInput().addClass('hidden');
        this.selectAll = container.find('.app-editor-select-all-container input');
        this.selectAll.change(this.#selectAllToggle.bind(this));

        this.itemTemplate = Template.load('#app-editor-item-template');
        this.fieldTemplate = Template.load('#app-editor-field-template');
        this.fieldIntroTemplate = Template.load('#app-editor-field-intro-template');
        this.tooltipTemplate = Template.load('#app-editor-field-tooltip');
        this.filters = {};
        this.projectWideItem = null;

        this.#buildEditor();
        this.manager = this.#createManager();

        if (this.data.snipit != null) {
            this.viewIntro.html(this.data.snipit);
            this.viewIntro.show();
        }
        if(this.data.userGuideReference != null) {
            let link = this.userGuideLink.find('a');
            link.attr('href', link.attr('data-link-base')+ this.data.userGuideReference);
            this.userGuideLink.show();
            this.viewToolNotesLink.hide();
        }
        else if(this.data.toolNotesReference != null) {
            let link = this.viewToolNotesLink.find('a');
            link.attr('href', link.attr('data-link-base')+ this.data.toolNotesReference);
            this.viewToolNotesLink.show();
            this.userGuideLink.hide();
        }

        this.log("constructed", this);
    }

    multiSelectInput() {
        return this.container.find('.app-editor-multi-select');
    }

    showTotals(totalsContent) {
        this.viewTotals.html(totalsContent);
        this.viewTotals.show();
    }

    saveEdits(onSavedFn, onInvalidFunction) {
        if (this.#validate()) {
            let data = this.data.toData();

            let saveFn = BESSAppProjectEditorAPIService.instance().apiSave.bind(BESSAppProjectEditorAPIService.instance());
            if (this.manager !== null && this.manager.saveFn !== null) {
                saveFn = this.manager.saveFn;
            }

            saveFn(data, function (result) {
                if (this.manager !== null) {
                    if (!this.manager.saved(result)) {
                        return;
                    }
                }

                let event = new BESSAppProjectEditorSavedEvent(result);
                this.fireEvent(event);
                onSavedFn();
            }.bind(this),);
        } else {
            onInvalidFunction();
        }
    }

    filterByFieldNo(fieldNo) {
        this.itemNodes.find('.app-editor-field').removeClass('app-filter-hidden');
        this.itemNodes.find('.app-item-label').addClass('app-filter-hidden');
        this.itemNodes.find('.app-field-label').removeClass('app-filter-hidden');
        this.multiSelectInput().find('input').setCheckedIf(false);
        if (fieldNo > 0) {
            this.filters['fieldNo'] = fieldNo;
            this.node.addClass('app-editor-compact');
            this.multiSelectInput().showAnimatedIf(true);

            this.itemNodes.find('.app-editor-field').not('.app-project-editor-field-' + (fieldNo - 1)).addClass('app-filter-hidden');
            this.itemNodes.find('.app-project-editor-field-' + (fieldNo - 1)).each(function () {
                let fieldNode = $(this);
                let itemName = fieldNode.parents('table').find('thead .app-orig-value').html();
                fieldNode.find('.app-item-label').html(itemName).removeClass('app-filter-hidden');
                fieldNode.find('.app-field-label').addClass('app-filter-hidden');
            });
        } else {
            delete this.filters['fieldNo'];
            this.node.removeClass('app-editor-compact');
            this.multiSelectInput().showAnimatedIf(false);
        }
    }

    filterByAttributeValue(attribute, value, filterValue) {
        if (value === null) {
            delete this.filters[attribute];
        } else {
            this.filters[attribute] = filterValue;
        }
        let fieldNo = this.data.getFieldNoForAttribute(attribute);
        let field = this.data.fields[fieldNo];
        if (value != null && field.inputType === BESSAppInputType.choice) {
            let choice = field.findChoiceMatching(value);
            if (choice != null) {
                value = choice.key;
            }
        }
        _.each(this.items, (x) => x.filterByFieldValue(fieldNo, value));
    }

    enableProjectWideMode() {
        this.#buildProjectWideEditorItem();
        if (this.manager !== null && this.manager !== undefined) {
            this.manager.updateState();
        }
        this.projectWideItem.itemView.fadeIn();
        this.itemNodes.fadeOut();
    }

    disableProjectWideMode(animated = true) {
        if (animated) {
            this.projectWideItem.itemView.fadeOut();
            this.itemNodes.fadeIn();
        } else {
            if (this.projectWideItem !== null) {
                this.projectWideItem.hide();
            }
            this.itemNodes.show();
        }

    }

    updateState() {
        this.hasChanges = this.data.hasChanges();
        _.each(this.items, function (item) {
            this.hasChanges = this.hasChanges || item.hasChanges()
        }.bind(this));
        this.onUpdatedFn();
        if (this.manager !== null && this.manager !== undefined) {
            this.manager.updateState();
        }
        this.#updateItemHeaders();
    }

    startEditing(item) {
        let itemIndex = _.findIndex(this.data.items, (x) => x.recordId === item.recordId);
        if (itemIndex >= 0) {
            let item = this.items[itemIndex];
            item.focus();
        }
    }

    addNewItem() {
        this.data.appendNewItem();
        this.#rebuildEditor();
        let item = _.last(this.items);
        item.focus();
        if (this.manager != null) {
            this.manager.addedNewItem(item);
        }
    }

    moveItemUp(item) {
        let swapIndex = item.itemIndex - 1;
        this.#swapItemsByIndex(item.itemIndex, swapIndex);
    }

    moveItemDown(item) {
        let swapIndex = item.itemIndex + 1;
        this.#swapItemsByIndex(item.itemIndex, swapIndex);
    }

    copyItem(item) {
        let newItemData = this.data.copyItem(item.itemData);
        this.#rebuildEditor();
        let newItem = this.items[newItemData.itemIndex];
        newItem.focus();
    }

    removeItem(item) {
        let itemIndex = item.itemIndex;
        this.items[itemIndex].fadeOut(function () {
            this.data.removeItem(item.itemData);
            this.#rebuildEditor();
        }.bind(this));
    }


    static #editorMap = null;

    #createManager() {

        if (BESSAppProjectEditor.#editorMap == null) {
            BESSAppProjectEditor.#editorMap = {
                'BESSAppProjectDetailsEditor': BESSAppProjectDetailsEditorManager,
                'BESSAppNewProjectEditor': BESSAppNewProjectEditorManager,
                'ResDwellingsEditor': BESSAppProjectDwellingsEditorManager,
                'NonResDwellingsEditor': BESSAppProjectDwellingsEditorManager,
                'DaylightEditor': BESSAppProjectDaylightEditorManager,
                'RainwaterTankEditor': BESSAppProjectRainwaterTankEditorManager,
                'EnergyNonResEditor': BESSAppProjectEnergyNonResSpacesProfileEditorManager,
                'EnergyBuildingNonResEditor': BESSAppProjectEnergyNonResBuildingProfileEditorManager,
                'InitiativesEditor': BESSAppProjectInitiativesEditorManager,
                'IWMWaterSpaceEditor': BESSAppProjectWaterSpaceEditorManager,
                'WaterSpaceEditor': BESSAppProjectWaterSpaceEditorManager,
            };
        }

        let managerType = nullIfUndefined(BESSAppProjectEditor.#editorMap[this.data.editorId]);
        if (managerType != null) {
            return new managerType(this);
        }
        return null;
    }

    #rebuildEditor() {
        this.#buildEditor();
        this.updateState();
        if (this.manager != null) {
            this.manager.onRebuild();
        }
    }

    #buildEditor() {
        BESSAppProjectEditorTagsInputField.reset();

        this.node.empty();
        this.items = [];
        this.inputs = [];

        this.itemTemplate.buildForEach(this.data.items, this.node, this.#buildEditorItemTemplate.bind(this));

        _.each(this.items, (item) => item.initialise());

        this.itemNodes = this.node.find('.app-editor-item-std');

        if (this.items.length === 0) {
            this.node.append(this.empty.clone());
        }
    }

    #buildProjectWideEditorItem() {
        if (this.projectWideItem != null) {
            this.projectWideItem.itemView.remove();
        }
        this.itemTemplate.buildForEach([this.data.createProjectWideItem()], this.node, this.#buildEditorProjectWideItemTemplate.bind(this));
        this.projectWideItem.initialise();
    }

    #buildEditorItemTemplate(itemData) {
        this.currentItemInputs = {
            allInputs: [],
        };
        let itemNode = this.itemTemplate.build();
        let tBody = itemNode.find('tbody');
        let tHead = itemNode.find('thead');

        this.fieldTemplate.buildForEach(this.data.fields, tBody, function (fieldData) {
            if (fieldData.introText != null && fieldData.introText) {
                let introNode = this.fieldIntroTemplate.build({
                    values: {
                        '.app-intro-text': fieldData.introText
                    }
                });
                tBody.append(introNode);
            }
            return this.#buildEditorFieldTemplate(itemData, fieldData);
        }.bind(this));

        if (this.data.items.length === 1 && !this.data.allowCreateDeleteItems) {
            tHead.remove();
        }
        this.items.push(new BESSAppProjectEditorItem(this, itemData, itemNode, this.currentItemInputs));

        return itemNode;
    }

    #buildEditorProjectWideItemTemplate(itemData) {
        this.currentItemInputs = {
            allInputs: [],
        };
        let itemNode = this.itemTemplate.build();
        let tBody = itemNode.find('tbody');

        this.fieldTemplate.buildForEach(this.data.fields, tBody, function (fieldData) {
            return this.#buildEditorProjectWideFieldTemplate(itemData, fieldData);
        }.bind(this));

        this.projectWideItem = new BESSAppProjectProjectWideEditorItem(this, itemData, itemNode, this.currentItemInputs);

        return itemNode;
    }

    #buildEditorFieldTemplate(itemData, fieldData, isProjectWide = false) {
        let fieldId = uuid4();

        let node = this.fieldTemplate.build({
            'values': {
                '.app-field-label': fieldData.label, '.app-label-units': fieldData.units,
            }, 'style': 'app-project-editor-field-' + fieldData.fieldNo,
        });
        node.find('.app-field-label').attr('for', fieldId);
        node.addClass('app-editor-field-' + fieldData.variable);
        let requiredNode = node.find('.app-item-label-required');
        requiredNode.remove();
        if (fieldData.isRequired) {
            node.find('label').append(requiredNode);
        }
        let input = BESSAppProjectEditorInput.for(this, itemData, fieldData, isProjectWide);
        input.node = node;
        this.currentItemInputs[fieldData.variable] = input;
        this.currentItemInputs.allInputs.push(input);
        this.inputs.push(input);
        let builtInput = input.build();
        node.find('.app-value').append(builtInput);
        node.find('.app-value-container').addClass(input.containerClass());
        node.find('input').attr('id', fieldId);
        node.find('input.first').attr('id', fieldId + '_first');
        node.find('input.second').attr('id', fieldId + '_second');
        node.find('label.first').attr('for', fieldId + '_first');
        node.find('label.second').attr('for', fieldId + '_second');
        node.find('select').attr('id', fieldId);

        if (fieldData.tooltip != null) {
            let tooltip = this.tooltipTemplate.build({
                'values': {'.content': fieldData.getTooltipContent()}
            });
            node.find('.aligner').append(tooltip);
        }

        if (fieldData.isHidden) {
            node.hide();
        }

        input.onChange(function (value) {
            this.#onInputChanged(input, value);
        }.bind(this));

        return node;
    }

    #buildEditorProjectWideFieldTemplate(itemData, fieldData) {
        return this.#buildEditorFieldTemplate(itemData, fieldData, true);
    }

    #updateItemHeaders() {
        _.each(this.items, (item) => item.updateItemHeader());
    }

    syncProjectWideInput(field, value) {
        _.each(this.items, (item) => item.syncProjectWideInput(field, value));
    }

    #swapItemsByIndex(itemIndex, swapIndex) {
        let swap1 = this.data.items[itemIndex];
        let swap2 = this.data.items[swapIndex];

        this.data.items[itemIndex] = swap2;
        this.data.items[swapIndex] = swap1;

        this.items[itemIndex].fadeOut(function () {
            this.#rebuildEditor();
            this.items[swapIndex].fadeInAndFocus();
        }.bind(this));

    }

    isValid() {
        let valid = true;
        _.each(this.items, function (x) {
            let itemValid = x.isValid();
            valid = valid && itemValid;
        })
        return valid;
    }

    #validate() {
        let valid = true;
        _.each(this.items, function (x) {
            let itemValid = x.validate();
            valid = valid && itemValid;
        })
        if (this.manager != null) {
            valid = valid && this.manager.isValid();
        }
        return valid;
    }

    #selectAllToggle() {
        let checked = this.selectAll.isChecked();
        this.multiSelectInput().find('input').not(this.selectAll).setCheckedIf(checked);
    }

    #onInputChanged(input, value) {
        if (this.syncing) {
            return;
        }
        let node = input.node;
        if (node.find('.app-editor-multi-select input').isChecked()) {
            this.#syncMultiSelectValues(value);
        }
        if (this.manager != null) {
            this.manager.onInputChanged(input, value)
        }
    }

    #syncMultiSelectValues(value) {
        this.syncing = true;
        _.forEach(this.inputs, function (input) {

            let node = input.node;
            if (node.isVisible()) {
                if (node.find('.app-editor-multi-select input').isChecked()) {
                    input.setValue(value);
                }
            }

        }.bind(this));
        this.syncing = false;
    }
}